import styled from '@emotion/styled';

export const CertificateBlinded = styled.div`
  &:before {
    content: '';
    display: block;
    position: absolute;
    left: 0;
    right: 0;
    top: 48px;
    bottom: 0;
    background-color: #0000ff00;
    z-index: 1;
  }
`;
